<template>
  <div>
    {{ row.account }}
    <div v-if="row.accountDetails.updatedAt">
      <b>Last&nbsp;updated&nbsp;{{ row.accountDetails.updatedAt }}</b>
    </div>
    <div v-if="row.accountDetails.transactionUser">
      by&nbsp;{{ row.accountDetails.transactionUser }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'tdAccount',
  props: ['row'],
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdAccount.vue